/* eslint-disable jsx-a11y/no-onchange */
import AudioBars from './AudioBars';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavItem,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import React, { useMemo } from 'react';
import { getColor, getColorText } from 'store/settings';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

const CameraOptions = ({
  isLoadingPreview,
  isRecording,
  deviceList,
  audioLevel,
  selectVideo,
  selectAudio,
  isMuted,
  muteAudioTrack,
  videoDeviceId,
}) => {
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  const StylesDropDown = useMemo(
    () => styled(DropdownToggle)`
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
      &:focus {
        background-color: ${colorStatus} !important;
      }
    `,
    [],
  );

  return (
    <>
      <div>{isLoadingPreview && 'Loading preview...'}</div>
      <div className="device-pickers">
        <UncontrolledButtonDropdown>
          <StylesDropDown disabled={isRecording} caret>
            {isRecording
              ? 'Cannot change audio devices while recording'
              : deviceList.video.find(
                  ({ deviceId }) => videoDeviceId === deviceId,
                )?.label || deviceList.video[0].label}
          </StylesDropDown>
          <DropdownMenu>
            {deviceList.video.map(({ label, deviceId }) => (
              <DropdownItem
                key={deviceId}
                onClick={() => selectVideo(deviceId)}
              >
                {label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledButtonDropdown>
        {
          <>
            <div className="audio-bars">
              <AudioBars
                muteAudioTrack={muteAudioTrack}
                isMuted={isMuted}
                audioLevel={audioLevel}
              />
            </div>
            <UncontrolledButtonDropdown>
              <StylesDropDown disabled={isRecording} caret>
                {isRecording
                  ? 'Cannot change audio devices while recording'
                  : deviceList.video.find(
                      ({ deviceId }) => videoDeviceId === deviceId,
                    )?.label || deviceList.audio[0].label}
              </StylesDropDown>
              <DropdownMenu>
                {deviceList.audio.map(({ label, deviceId }) => (
                  <DropdownItem
                    key={deviceId}
                    onClick={() => selectAudio(deviceId)}
                  >
                    {label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </>
        }
      </div>
      <style jsx>{`
        .device-pickers {
          margin-top: 20px;
          text-align: center;
        }

        .audio-bars {
          margin: 20px 0;
        }
      `}</style>
    </>
  );
};

export default CameraOptions;
